// extracted by mini-css-extract-plugin
var _1 = "TextMultiValuedListMoreItem-moduleTextMultiValuedListMoreItem___Z4Wr MultiValuedListMoreItem-moduleMultiValuedListMoreItem__SSTEE";
export { _1 as "TextMultiValuedListMoreItem" }
